import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createButtonLabel: {
		id: 'polaris-component-collection-create.form.create-button-label',
		defaultMessage: 'Create roadmap',
		description: 'Label for create button',
	},
});
